export const BlockedIcon = 'assets/icons/blocked-seat.svg';
export const VerifiedIcon = 'assets/icons/verified.svg';
export const editedIcon = 'assets/icons/edited.svg';
export const reservedIcon = 'assets/icons/reserved.svg';
export const PaidIcon = 'assets/icons/paid.svg';
export const VectorIcon = 'assets/icons/Vector.svg';

// Topview is scaled up to 4 times with zooming event
export const TopViewMaxScaleValue = 4;
// ratio to apply cache to the plan, 10 is the best value to get performance and quality on medium size plans
// you can move this constant to a configurable file, and adjust its value according to the plans sizes by database
export const BlockViewCachePixelRatio = 10;
// the factor with which zooming will scale: the event will scale dimensions * 1.5 each time
export const BlockViewScaleByFactor = 1.5;
// the factor with which the minimap will be scaled: 0.25 of the real plan
export const MinimapScaleFactor = 0.25;
// blocked seat icon
export const BlockedSeatIcon = 'assets/icons/blocked-seat.svg';
// search result icon
export const SearchResultIcon = 'assets/icons/seat-search-result.svg';
export const seatsChunkSize = 2000;
// seat box width and height
export const SeatBoxSize = 12;
// synchronizing local and remote selection will be executed after this timeout value (in ms)
export const SynchronizeSelectionUpdateTimeout = 2000;
